import { AppThemeConfig } from "../types";

export const createTheme = (themeConfig: AppThemeConfig) => {
  return {
    "--cx-color-neutral-lighter": themeConfig.colors?.neutral?.lighter,
    "--cx-color-neutral-light": themeConfig.colors?.neutral?.light,
    "--cx-color-neutral-regular": themeConfig.colors?.neutral?.regular,
    "--cx-color-neutral-dark": themeConfig.colors?.neutral?.dark,
    "--cx-color-neutral-darker": themeConfig.colors?.neutral?.darker,
    "--cx-color-brand-primary-lighter": themeConfig.colors?.primary?.lighter,
    "--cx-color-brand-primary-light": themeConfig.colors?.primary?.light,
    "--cx-color-brand-primary-regular": themeConfig.colors?.primary?.regular,
    "--cx-color-brand-primary-dark": themeConfig.colors?.primary?.dark,
    "--cx-color-brand-primary-darker": themeConfig.colors?.primary?.darker,
    "--cx-color-brand-secondary-regular":
      themeConfig.colors?.primary?.secondary,
    "--cx-color-brand-tertiary-regular": themeConfig.colors?.primary?.tertiary,
    "--cx-color-success-lighter": themeConfig.colors?.success?.lighter,
    "--cx-color-success-light": themeConfig.colors?.success?.light,
    "--cx-color-success-regular": themeConfig.colors?.success?.regular,
    "--cx-color-success-dark": themeConfig.colors?.success?.dark,
    "--cx-color-success-darker": themeConfig.colors?.success?.darker,
    "--cx-color-highlight-lighter": themeConfig.colors?.highlight?.lighter,
    "--cx-color-highlight-light": themeConfig.colors?.highlight?.light,
    "--cx-color-highlight-regular": themeConfig.colors?.highlight?.regular,
    "--cx-color-highlight-dark": themeConfig.colors?.highlight?.dark,
    "--cx-color-highlight-darker": themeConfig.colors?.highlight?.darker,
    "--cx-color-error-lighter": themeConfig.colors?.error?.lighter,
    "--cx-color-error-light": themeConfig.colors?.error?.light,
    "--cx-color-error-regular": themeConfig.colors?.error?.regular,
    "--cx-color-error-dark": themeConfig.colors?.error?.dark,
    "--cx-color-error-darker": themeConfig.colors?.error?.darker,
    "--cx-color-warning-lighter": themeConfig.colors?.warning?.lighter,
    "--cx-color-warning-light": themeConfig.colors?.warning?.light,
    "--cx-color-warning-regular": themeConfig.colors?.warning?.regular,
    "--cx-color-warning-dark": themeConfig.colors?.warning?.dark,
    "--cx-color-warning-darker": themeConfig.colors?.warning?.darker,
    "--cx-border-radius-default": themeConfig.borderRadius?.default,
    "--cx-border-radius-checkbox": themeConfig.borderRadius?.checkbox,
    "--cx-border-radius-modal": themeConfig.borderRadius?.modal,
    "--cx-border-radius-card": themeConfig.borderRadius?.card,
    "--cx-border-radius-alert": themeConfig.borderRadius?.alert,
    "--cx-font-default": themeConfig.font?.default,
  };
};

export const getStyleVariables = () => {
  const cssVariables = Array.from(document.styleSheets)
    .filter(
      (sheet) =>
        sheet.href === null || sheet.href.startsWith(window.location.origin)
    )
    .reduce<string[]>(
      (acc, sheet) =>
        (acc = [
          ...acc,
          ...Array.from(sheet.cssRules).reduce<string[]>(
            (def, rule) =>
              (def =
                rule instanceof CSSStyleRule && rule.selectorText === ":root"
                  ? [
                      ...def,
                      ...Array.from(rule.style).filter((name) =>
                        name.startsWith("--cx-")
                      ),
                    ]
                  : def),
            []
          ),
        ]),
      []
    )
    .map((cssKey) => {
      const val = window
        .getComputedStyle(document.body)
        .getPropertyValue(cssKey);
      return `${cssKey}: ${val}`;
    });

  return `:root {\n${cssVariables.join(";\n  ")};\n}`;
};

export const getSumsubCustomStyle = () => {
  const styleVariables = getStyleVariables();
  return `${styleVariables};\n   div, h2, h3, h4, p, a, button, span {\n font-family: var(--cx-font-default), sans-serif;\n }\n\nh2 {\nfont-size: 32px !important;\n font-weight: 700;\n color: black;\n padding-bottom: 0px !important;\n}\n\np {\n  color: var(--cx-color-black);\n  font-size: 16px;\n  line-height: 24px;\n}\n\na {\ncolor: var(--cx-color-brand-primary-regular);\n}\n\na:hover {\n  border-bottom: 1px solid var(--cx-color-brand-primary-regular);\n}\n\n.step .line {\n  background-color: var(--cx-color-neutral-light);\n}\n\n.step i.bullet {\n  border-color: var(--cx-color-neutral-light);\n}\n\n.step.active i.line, .step.success i.line {\n  background-color: var(--cx-color-brand-primary-regular);\n}\n\n.step.active i.bullet:before, .step.active.success i.bullet:before {\n  background-color: var(--cx-color-brand-primary-regular);\n}\n\n.row>h2 {\n  margin-top: -40px;\n}\n\n.row>h2>p {\n  font-size: 32px;\n  font-weight: 700;\n  margin: 0;\n  text-transform: capitalize;\n}\n\nsection {\n  margin: 40px auto;\n}\n\ninput {\n  color: var(--cx-color-black);\n  font-weight: 600;\n  outline: none;\n}\n\nsection.content {\n  background-color: var(--cx-color-white);\n  color: var(--cx-color-black);\n  padding: 40px;\n  box-shadow: 0px 1px 4px rgba(102, 102, 102, 0.2);\n  border-radius: var(--cx-border-radius-modal);\n}\n\nsection .row {\n  margin: 40px 0 0;\n}\n\n.upload .upload-payment-item .upload-item {\n  box-shadow: 0px 1px 4px rgba(102, 102, 102, 0.2);\n}\n\n.mobile-button {\n  box-shadow: 0px 1px 4px rgba(102, 102, 102, 0.2);\n}\n\nsection.content .create-applicant-landing>.markdown-instructions>p {\n  margin: 0px;\n  color: var(--cx-color-neutral-darker);\n  font-size: 16px;\n}\n\n.checkbox input:checked~.checkmark {\n  background-color: var(--cx-color-brand-primary-regular);\n  border-color: var(--cx-color-brand-primary-regular);\n}\n\nlabel.checkbox {\n  padding-left: 32px;\n  margin-right: 36px;\n}\n\n.checkbox i.checkmark {\n  width: 24px;\n  height: 24px;\n  border-radius: var(--cx-border-radius-alert);\n  border: 1.5px solid;\n  border-color: var(--cx-color-neutral-light);\n  box-sizing: border-box;\n}\n\n.checkbox input:focus~.checkmark {\n  border-color: var(--cx-color-neutral-light);\n}\n\n.checkbox .checkmark:after {\n  left: 8px;\n  top: 3px;\n}\n\nbutton.submit, button.back {\n  text-transform: capitalize;\n  border-radius: var(--cx-border-radius-button);\n  height: 48px;\n  padding: 8px 24px;\n  font-weight: 600;\n  font-size: 16px;\n  background-image: none !important;\n  transform: none !important;\n  box-shadow: none !important;\n  transition: all 0.2s linear;\n   background: none;\n}\n\nbutton.submit {\n  background-color: var(--cx-color-brand-primary-regular);\n}\n\nbutton.back {\n  color: var(--cx-color-brand-primary-regular);\n  border: 2px solid var(--cx-color-neutral-light);\n}\n\n.upload .upload-payment-item .upload-item h4, .upload .upload-payment-item .upload-item h4 .accent {\n  color: var(--cx-color-brand-primary-regular);\n}\n\n.upload .upload-payment-item .upload-item i.upload-icon {\n  color: var(--cx-color-brand-primary-regular);\n}\n\nbutton.submit .arrow, button[type=submit] .arrow {\n  margin-left: 4px;\n}\n\nbutton.back .arrow {\n  margin-right: 4px;\n}\n\n.round-icon {\n  background-color: var(--cx-color-brand-primary-regular) !important;\n  background-image: none !important;\n}\n\n  div.sumsub-logo\n { display: none;\n }\n`;
};

export const hexToRgb = (hex: string) => {
  if (!hex.startsWith("#")) return hex; // if not starting with '#' means it's already an RGB color
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(
        result[3],
        16
      )}` // R G B;
    : null;
};
